import { useColorCollections } from "../../color-collections";
import { useEditColorCollectionsStore } from "../../../js/stores/edit-color-collections-store";
import { SharedIcon } from "../shared/shared-icon";

export function NewColorCollectionButton() {
  const { newButtonLabel } = useColorCollections();
  const openNewButtonModal = useEditColorCollectionsStore(
    (state) => state.openNewButtonModal
  );

  return (
    <button
      className="color-collection-action color-collection-action--main"
      type="button"
      onClick={openNewButtonModal}
    >
      {newButtonLabel}
      <SharedIcon iconName="#sprite-plus" />
    </button>
  );
}
